/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicalAidOptionModel } from '../../models/medical-aid-option-model';

export interface MedicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost$Params {
  medicalAidId: string;
  medicalAidSchemeId: string;
      body?: MedicalAidOptionModel
}

export function medicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost(http: HttpClient, rootUrl: string, params: MedicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, medicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost.PATH, 'post');
  if (params) {
    rb.path('medicalAidId', params.medicalAidId, {});
    rb.path('medicalAidSchemeId', params.medicalAidSchemeId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<string>;
    })
  );
}

medicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost.PATH = '/MedicalAid/MedicalAidOptionSave/{medicalAidId}/{medicalAidSchemeId}';
